import React, { useEffect, useState } from 'react';
import { useAuthContext } from '../auth/contexts/AuthContext';
import PAdminDashboard from './pages/PAdminDashboard';
import PAdminInvestors from './pages/PAdminInvestors';
import { useNavigate } from 'react-router-dom';
import HAppRoutes from '../../app/features/routes/helpers/HAppRoutes';
import InvestorRoutes from '../investor/InvestorRoutes';
import PAdminDocumentAccess from './pages/PAdminDocumentAccess';
import PAdminDocumentDownloadLogs from './pages/PAdminDocumentDownloadLogs';
import PAdminEmailNotifications from './pages/PAdminEmailNotifications';
import PAdminDocumentEmailNotifications from './pages/PAdminDocumentEmailNotifications';
import PAdminUserEmailNotifications from './pages/PAdminUserEmailNotifications';
import PAdminNotificationMonitoring from './pages/PAdminNotificationMonitoring';

type AdminProps = {
	page: string;
};
const Admin = (props: AdminProps) => {
	const { page } = props;

	const auth = useAuthContext();
	const navigate = useNavigate();

	useEffect(() => {
		if (auth) {
			if (auth.authContext !== 'employee' || auth.isInvestor === true) {
				navigate(HAppRoutes.getPath(InvestorRoutes.dashboard.tag));
			}
		}
	}, [auth, navigate]);

	const [isLoading] = useState(false);

	const renderPage = () => {
		switch (page) {
			case 'dashboard':
				return <PAdminDashboard />;
			case 'investors':
				return <PAdminInvestors />;
			case 'document_access_logs':
				return <PAdminDocumentAccess />;
			case 'document_access_capital_calls':
				return <PAdminDocumentDownloadLogs />;
			case 'email_notifications':
				return <PAdminEmailNotifications />;
			case 'document_email_notifications':
				return <PAdminDocumentEmailNotifications />;
			case 'user_email_notifications':
				return <PAdminUserEmailNotifications />;
			case 'notification_monitoring':
				return <PAdminNotificationMonitoring />;
			default:
				return <>404</>;
		}
	};

	return <>{!isLoading ? <>{renderPage()}</> : ''}</>;
};

export default Admin;
